import { Link,useLocation,useNavigate,NavLink } from "react-router-dom";
import { NAV_LINKS,USER_ROLES } from "../../Utilities/configlinks";
import { useAuth } from "../../ContextApp/AuthContext";
function Barmenu(){
const mylocation=useLocation();
const {user,logout}=useAuth()
const currentpath=mylocation.pathname
const links = NAV_LINKS[user.type_compte]|| NAV_LINKS.Visiteur;
const navigate=useNavigate()
const Showmenu=()=>{
    
    let mynav=document.getElementById('navigation');

    if(mynav.classList.contains("navigation-show")){
        mynav.classList.remove("navigation-show");
        document.getElementById('menu-small').innerHTML="&#9776;";
    }   else{
        mynav.classList.add("navigation-show");
        document.getElementById('menu-small').innerHTML="&#10005;";
           
    }

}
    return(
        <>
  <nav className="navbar navbar-expand-lg navbar-dark bg-primary shadow py-2">
    <div className="container">
      {/* Brand / Logo */}
      <Link className="navbar-brand fw-bold fs-4" to="/">
        <i className="bi bi-book-half me-2"></i> {/* Icône optionnelle */}
        Mon École
      </Link>

      {/* Bouton Burger pour mobile */}
      <button 
        className="navbar-toggler" 
        type="button" 
        data-bs-toggle="collapse" 
        data-bs-target="#navbarNav" 
        aria-controls="navbarNav" 
        aria-expanded="false" 
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      {/* Contenu du menu */}
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav ms-auto align-items-center justify-content-end">
          {links.map((link, index) => (
            <li className="nav-item" key={index}>
              <NavLink 
                to={link.path} 
                className={({ isActive }) => 
                  `nav-link px-3 ${isActive ? 'active fw-bold text-info' : ''}`
                }
              >
                {link.label}
              </NavLink>
            </li>
          ))}

          {/* Bouton de déconnexion */}
          {user.type_compte !== USER_ROLES.VISITEUR && (
            <li className="nav-item ms-lg-3">
              <button 
                type="button" 
                onClick={async () => {
                  try {
                    await logout();
                    navigate('/');
                  } catch (err) {
                    navigate('/');
                  }
                }}  
                className="btn btn-outline-danger btn-sm px-4 rounded-pill"
              >
                Déconnexion
              </button>
            </li>
          )}
        </ul>
      </div>
    </div>
  </nav>
</>

    )
}
export default Barmenu;